"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPath = exports.GetPathData = void 0;
const arrow_1 = require("./arrow");
const CircularBubble_1 = require("./CircularBubble");
const polygon_1 = require("./polygon/polygon");
const speechBubble_1 = require("./speechBubble");
const starburst_1 = require("./starburst");
const types_paths_1 = require("./types.paths");
const utility_paths_1 = require("./utility.paths");
function GetPathData(shape) {
    let pathData = '';
    switch (shape.type) {
        case types_paths_1.ShapeTypes.Polygon:
            pathData = polygon_1.getPolygonPath(shape);
            break;
        case types_paths_1.ShapeTypes.StarBurst:
            pathData = starburst_1.getStarburstPath(shape);
            break;
        case types_paths_1.ShapeTypes.Arrow:
            pathData = arrow_1.getArrowPath(shape);
            break;
        case types_paths_1.ShapeTypes.DoubleSidedArrow:
            pathData = arrow_1.getArrowPath(shape, 2);
            break;
        case types_paths_1.ShapeTypes.SpeechBubble:
            pathData = speechBubble_1.getRectangularSpeechBubblePath(shape);
            break;
        case types_paths_1.ShapeTypes.CircularSpeechBubble:
            pathData = CircularBubble_1.getCircularBubblePath(shape);
            break;
    }
    return pathData;
}
exports.GetPathData = GetPathData;
function GetPath(shape, pathProperties) {
    const pathData = GetPathData(shape);
    const pathHtmlAttributes = utility_paths_1.generateHtmlAttributesFromPathProperties(pathProperties);
    const path = `<path d="${pathData}" ${pathHtmlAttributes} />`;
    return path;
}
exports.GetPath = GetPath;
//# sourceMappingURL=index.js.map